import * as React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react';

interface ModalFormProps {
  trigger: JSX.Element;
  form: JSX.Element;
}

export const ModalForm = ({ trigger, form }: ModalFormProps): JSX.Element => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  function handleClick(event: React.MouseEvent): void {
    event.preventDefault();
    onOpen();
  }

  function handleSuccess(): void {
    onClose();
  }

  return (
    <>
      {React.cloneElement(trigger, { onClick: handleClick })}
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        size='5xl'
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            {React.cloneElement(form, {
              template: 'modal',
              onSubmit: handleSuccess,
              onClose,
            })}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
